<p-dialog
  modal="true"
  styleClass="atlas-dialog-s"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>{{ 'profiles.view.committees.add-profile-to-committee' | translate | ucfirst }}</h4>
  </ng-template>

  <div class="mct-flex mct-col mct-gap-27"  >
    <div>
      <div class="light-text">
        {{ 'profiles.view.committees.committee' | translate | ucfirst }}
      </div>
      <p-select
        #committee
        [(ngModel)]="member.CommitteeID"
        placeholder="{{ 'profiles.view.committees.select-a-committee' | translate }}"
        [options]="committees"
        appendTo="body"
        [style]="{ width: '100%' }"
      ></p-select>
    </div>
    <div>
      <div class="light-text">
        {{ 'profiles.view.committees.role' | translate | ucfirst }}
      </div>
      <input type="text" [(ngModel)]="member.Title" class="form-control" />
    </div>
    <div>
      <div class="light-text">
        {{ 'profiles.view.committees.start-date' | translate | ucfirst }}
      </div>
      <wl-date-selector #startDate [(ngModel)]="member.MemberSince" appendTo="body"></wl-date-selector>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-justify-end mct-items-center" >
      <button pButton type="button" (click)="cancel()"
        class="atlas-btn atlas-btn-secondary">{{ 'common.cancel' | translate | uppercase }}</button>
      <button pButton type="button" (click)="save()"
        class="atlas-btn atlas-btn-primary">{{ 'common.save' | translate | uppercase }}</button>
    </div>
  </ng-template>
</p-dialog>
